import { useState } from "react";
import { useSelector } from "react-redux";
import { StoreProptypes } from "../../PropTypes/StoreProptypes";
import { G2ReviewUrlService } from "../../Services/UseG2ReviewService";
import { useDispatch } from "react-redux";

export default function useG2Review() {
    const [loading, setLoading] = useState(false);
    const { user } = useSelector((store: StoreProptypes) => store);
    const partner_name = process.env.REACT_APP_G2_PARTNER_NAME
    const dispatch = useDispatch();
    const getReviewUrl = async () => {
        setLoading(true);

        try {
            const G2ReviewUrl = await G2ReviewUrlService(partner_name ?? '', user?.email ?? '', dispatch)
            return G2ReviewUrl; // cleaner     
        } catch (err) {
            console.error(err);
        }

        setLoading(false);
    };

    return { loading, getReviewUrl };
}
